/* eslint-disable camelcase */
import { ref } from 'vue'
import { RouteLocationRaw } from 'vue-router'

export interface BreadcrumbItem {
	text?: string
	to?: RouteLocationRaw
	loading?: boolean
	__dynamic_key__?: string
}

const dynamicItemPrefix = '__dynamic_item__'

const items = ref<BreadcrumbItem[]>([])

function getInstance() {
	const route = useRoute()
	const { te, t } = useI18n()

	watch(
		() => route.query,
		() => {
			items.value = []

			route.matched.forEach((routeRecord) => {
				let text: string | undefined = routeRecord.meta.title
				let dynamicKey: string | undefined = undefined
				const to = routeRecord.path
				let loading = false

				if (routeRecord.meta.dynamicBreadcrumb) {
					loading = true
					dynamicKey = `${dynamicItemPrefix}${routeRecord.meta.dynamicBreadcrumb}`
				}

				if (text || loading || dynamicKey) {
					text = text && !loading && te(text) ? t(text) : text
					items.value.push({ text, to, loading, __dynamic_key__: dynamicKey })
				}
			})
		}
	)

	return {
		items
	}
}

export function setDynamicBreadcrumb(key: string, text: string) {
	items.value = items.value.map((item) => {
		if (item.__dynamic_key__ === `${dynamicItemPrefix}${key}`) {
			item.text = text
			item.loading = false
		}

		return item
	})
}

let instance: Nullable<ReturnType<typeof getInstance>> = null
export function useBreadcrumb() {
	if (!instance) {
		instance = getInstance()
	}

	return instance
}
